import { render, staticRenderFns } from "./SelectMainCharacteristic.vue?vue&type=template&id=df27fd46&scoped=true&"
import script from "./SelectMainCharacteristic.vue?vue&type=script&lang=js&"
export * from "./SelectMainCharacteristic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df27fd46",
  null
  
)

export default component.exports